import { type DropzoneOptions, useDropzone } from 'react-dropzone';
import { Trans } from 'react-i18next';
import {
  StyledAudioFileIcon,
  StyledContainer,
  StyledHintText,
  StyledLink,
} from './styles';

const Dropzone = (props: DropzoneOptions) => {
  const { open, getRootProps, getInputProps } = useDropzone({ ...props });

  return (
    <StyledContainer {...getRootProps()}>
      <input {...getInputProps()} />
      <StyledAudioFileIcon />
      <StyledHintText align="center">
        <Trans i18nKey="general:dropzone:hint">
          <StyledLink onClick={open} />
        </Trans>
      </StyledHintText>
    </StyledContainer>
  );
};

export default Dropzone;
